import PrivacyHero from "./components/PrivacyHero";
import PrivacyContent from "./components/PrivacyContent";

export default function PrivacyPage() {
  return (
    <main>
      <PrivacyHero />
      <PrivacyContent />
    </main>
  );
}